export const FORMAT_HEADING_1_MENU_ITEM = {
	key: 'block-menu-format-heading-1',
};

export const FORMAT_HEADING_2_MENU_ITEM = {
	key: 'block-menu-format-heading-2',
};

export const FORMAT_HEADING_3_MENU_ITEM = {
	key: 'block-menu-format-heading-3',
};

export const FORMAT_HEADING_4_MENU_ITEM = {
	key: 'block-menu-format-heading-4',
};

export const FORMAT_HEADING_5_MENU_ITEM = {
	key: 'block-menu-format-heading-5',
};

export const FORMAT_HEADING_6_MENU_ITEM = {
	key: 'block-menu-format-heading-6',
};

export const FORMAT_PARAGRAPH_MENU_ITEM = {
	key: 'block-menu-format-paragraph',
};

export const FORMAT_QUOTE_MENU_ITEM = {
	key: 'block-menu-format-quote',
};

export const FORMAT_EXPAND_MENU_ITEM = {
	key: 'block-menu-format-expand',
};

export const FORMAT_LAYOUT_MENU_ITEM = {
	key: 'block-menu-format-layout',
};

export const FORMAT_PANEL_MENU_ITEM = {
	key: 'block-menu-format-panel',
};

export const FORMAT_CODE_BLOCK_MENU_ITEM = {
	key: 'block-menu-format-code-block',
};

export const FORMAT_BULLETED_LIST_MENU_ITEM = {
	key: 'block-menu-format-bulleted-list',
};

export const FORMAT_NUMBERED_LIST_MENU_ITEM = {
	key: 'block-menu-format-numbered-list',
};

export const FORMAT_TASK_LIST_MENU_ITEM = {
	key: 'block-menu-format-task-list',
};
